import {
  GET_LEAD_CAPTURE_DETAIL,
  GET_LEAD_CAPTURE_DETAIL_SUCCESS,
  GET_LEAD_CAPTURE_DETAIL_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getLeadCaptureDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_CAPTURE_DETAIL:
      return { ...state, loading: true };
    case GET_LEAD_CAPTURE_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_LEAD_CAPTURE_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getLeadCaptureDetailReducer;
